import { render, staticRenderFns } from "./QuestionIcon.vue?vue&type=template&id=63a2fb94&scoped=true&"
import script from "./QuestionIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuestionIcon.vue?vue&type=style&index=0&id=63a2fb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2fb94",
  null
  
)

export default component.exports